<dx-toolbar>
  <dxi-item location="before"
    ><span [class]="titleClass">Detay</span>
  </dxi-item>
  <dxi-item location="after" locateInMenu="after" [visible]="!isEditing">
    <dx-button
      text="Düzenle"
      icon="edit"
      stylingMode="outlined"
      type="default"
      (onClick)="handleEditClick()"
    ></dx-button>
  </dxi-item>
  <dxi-item location="after" locateInMenu="after" [visible]="isEditing">
    <dx-button
      text="Kaydet"
      stylingMode="outlined"
      type="default"
      (onClick)="handleSaveButtonClick($event)"
    ></dx-button>
  </dxi-item>
  <dxi-item location="after" locateInMenu="after" [visible]="isEditing">
    <dx-button
      text="İptal"
      (onClick)="handleCancelEditClick()"
      stylingMode="text"
    ></dx-button>
  </dxi-item>
</dx-toolbar>
